import { BaseObject } from '../../core/business-objects/base-object/base-object.model';

/**
 * Calculate the next value for highlightedResultId. "Next" being either -1 or +1 from the
 * currently highlightedResultId item.
 *
 * If items is empty, return empty string
 *
 * If current is empty string and
 * - delta is positive, return the first item id
 * - delta is negative, return the last item id
 *
 * If current is not empty and
 * - delta is positive, return the next item in the list wrapping to the start
 *   if current item is the last
 * - delta is negative, return the previous item in the list wrapping to the end
 *   if current item is the first
 *
 * @param current {string} the id of the currently highlightedResultId item
 * @param delta {number} -1 for previous item, +1 for the next item
 * @param items {Array<{id: string}>} a list of objects with an id property
 */
export const calcSelected = (
    current: string,
    delta: number,
    items: Array<{id: string}>
): string => {

    if (items.length === 0) {
        return '';
    }

    const pos = current === '' ?
        -1 :
        items.findIndex(m => m.id === current);

    if (pos === -1) {
        return delta > 0 ? items[0].id : items[items.length - 1].id;
    }

    const nextPos = pos + delta >= 0 ?
        (pos + delta) % (items.length) :
        items.length - 1;

    if (!items[nextPos]) {
        return '';
    }

    return items[nextPos].id;
};



// WEBPACK FOOTER //
// ./src/app/helpers/calc-selected.ts